module.exports = __webpack_public_path__ + "static/media/HeatCorpSTEM_W-9.9390deb8.pdf";